import usePrivateAxios from '@/common/api/usePrivateAxios';
import { LastReviewValidationSchema } from '@/common/schemas/lastReview.schema';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceExecutionObjectiveDisapproveProps {
  objectiveId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    LastReviewValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceExecutionObjectiveDisapprove = ({
  objectiveId,
  options,
}: UseMaintenanceExecutionObjectiveDisapproveProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceExecutionObjectiveApprove'],
    mutationFn: (form) => {
      return privateAxios.put(`/maintenance/execution_objectives/${objectiveId}`, {
        execution_objective: {
          last_review_attributes: {
            state: 'disapproved',
            description: form.description,
          },
        },
      });
    },
    ...options
  });
}
